<template src="../../assets/views/templates/faturas/faturas.html"></template>

<style>
@import "../../assets/views/styles/Faturas.css";
</style>

<script>
import HistoricoFatura from "./HistoricoFatura";

import {
  changeCssAtt,
  tryToCallInvoicesApi,
} from "../../assets/views/scripts/faturas/invoice_functions";
import { cnpjFormatter } from "../../assets/views/functions";

export default {
  components: {
    HistoricoFatura,
  },
  data() {
    return {
      previousDateInvoice: null,
      previousValueInvoice: null,
      currentDateInvoice: null,
      currentValueInvoice: null,
      taxQtSales: null,
      taxValueSales: null,
      taxValue: null,
      userActive: null,
      userPerFranchise: null,
      userValuePerFranchise: null,
      userQtFranchiseInvoiced: null,
      userTotalValueFranchise: null,
      cancelAllowed: null,
      cancelQtTotal: null,
      cancelTotalValue: null,
      cancelOutLimit: null,
      cancelOutLimitValue: null,
      cancelTaxOutLimitValue: null,
      creditQtSales: null,
      creditValueSales: null,
      creditValue: null,
      fields: [
        {
          key: "typeItem",
          sortable: true,
          label: "Tipo Item",
          tdClass: "nowrap",
        },
        {
          key: "details",
          label: "Detalhes",
          tdClass: "nowrap",
        },
      ],
      itemsHistInvoice: [],
    };
  },
  async mounted() {
    changeCssAtt(this.observer, this.$nextTick);

    const invoiceApiResponse = await tryToCallInvoicesApi(
      cnpjFormatter(localStorage.getItem("cnpj")),
      this
    );

    this.taxQtSales = invoiceApiResponse.taxQtSales;
    this.taxValueSales = invoiceApiResponse.taxValueSales;
    this.taxValue = invoiceApiResponse.taxValue;

    this.creditQtSales = invoiceApiResponse.creditQtSales;
    this.creditValueSales = invoiceApiResponse.creditValueSales;
    this.creditValue = invoiceApiResponse.creditValue;

    this.userActive = invoiceApiResponse.userActive;
    this.userPerFranchise = invoiceApiResponse.userPerFranchise;
    this.userValuePerFranchise = invoiceApiResponse.userValuePerFranchise;
    this.userQtFranchiseInvoiced = invoiceApiResponse.userQtFranchiseInvoiced;
    this.userTotalValueFranchise = invoiceApiResponse.userTotalValueFranchise;

    this.cancelAllowed = invoiceApiResponse.cancelAllowed;
    this.cancelQtTotal = invoiceApiResponse.cancelQtTotal;
    this.cancelTotalValue = invoiceApiResponse.cancelTotalValue;
    this.cancelOutLimit = invoiceApiResponse.cancelOutLimit;
    this.cancelOutLimitValue = invoiceApiResponse.cancelOutLimitValue;
    this.cancelTaxOutLimitValue = invoiceApiResponse.cancelTaxOutLimitValue;

    this.itemsHistInvoice = invoiceApiResponse.histInvoice;
    this.previousDateInvoice = invoiceApiResponse.previousDateInvoice;
    this.previousValueInvoice = invoiceApiResponse.previousValueInvoice;
    this.currentDateInvoice = invoiceApiResponse.currentDateInvoice;
    this.currentValueInvoice = invoiceApiResponse.currentValueInvoice;
  },
};
</script>